import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82cbf3ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "diagnosis-table-container" }
const _hoisted_2 = { key: "action" }
const _hoisted_3 = {
  class: "pdx",
  key: "pdx"
}
const _hoisted_4 = { key: "drgModifier" }
const _hoisted_5 = {
  key: "code",
  class: "code"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: "description",
  class: "text-ellipsis"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: "poa" }
const _hoisted_11 = { key: "quality" }
const _hoisted_12 = { key: "risk" }

import { QTableProps } from 'quasar';
import DataTable from 'components/grouper-common/DataTable.vue';
import { ref } from 'vue';
import { useGrouperStore } from 'stores/GrouperStore';
import { DiagnosisCode } from 'src/contracts/diagnosisCode';
import { CodeType } from 'src/contracts/codeType';
import { storeToRefs } from 'pinia';
import {
    presentOnAdmissionDisplayMap,
    presentOnAdmissionMap,
    presentOnAdmissionsDisplayValues
} from 'src/common/poaUtll';


export default /*#__PURE__*/_defineComponent({
  __name: 'DiagnosisPane',
  setup(__props) {

const columns: QTableProps['columns'] = [
    {name: 'action', align: 'center', label: '', field: 'action', sortable: false},
    {name: 'pdx', align: 'center', label: '', field: 'pdx', sortable: false},
    {name: 'drgModifier', align: 'center', label: 'DRG Modifier', field: 'drgModifier', sortable: false},
    {name: 'code', align: 'left', label: 'Code', field: 'code', sortable: false},
    {name: 'description', align: 'left', label: 'Diagnosis Description', field: 'description', sortable: false},
    {name: 'poa', align: 'center', label: 'POA', field: 'poa', sortable: false},
    {name: 'quality', align: 'center', label: 'Quality', field: 'quality', sortable: false},
    {name: 'risk', align: 'center', label: 'Risk', field: 'risk', sortable: false}
];

const { diagnosisCodes } = storeToRefs(useGrouperStore());
let currentCode: DiagnosisCode | undefined = undefined;
let currentRow = ref(-1);

function setPOAsToYes() {
    diagnosisCodes.value?.map((row) => {
        row.poa = 'Y';
    })
}

function calculateDRG() {
  useGrouperStore().calculateDrg(true, true);
}

function alternateRow(index: number): string {
    if (editing(index)) {
        return 'editing-row'
    } else if (index % 2 === 1) {
        return 'iodine-alternate-table-row';
    }
    return 'bg-white text-black'
}

function deleteCode(index: number): void {
    diagnosisCodes.value?.splice(index, 1);
    currentRow.value = -1;
}

function editCode(index: number, editing = true): void {
    // reset previous row before editing new row
    if (currentRow.value != index && currentRow.value > -1) {
        diagnosisCodes.value[currentRow.value] = currentCode || diagnosisCodes.value[currentRow.value];
    }
    // make a copy of the row for reset
    currentCode = index >= 0 ? diagnosisCodes.value[index] : undefined;
    currentRow.value = editing ? index : -1;
}

function editing(index: number): boolean {
    return currentRow.value === index;
}

function saveCode() {
    currentRow.value = -1;
}

function resetCode(index: number): void {
    diagnosisCodes.value[index] = currentCode || diagnosisCodes.value[index];
    currentRow.value = -1;
}

function makePrinciple(index: number): void {
    diagnosisCodes.value?.unshift(diagnosisCodes.value?.splice(index, 1)[0]);
}

function searchCodes(text: string | undefined, index: number) {
    diagnosisCodes.value[index].description = useGrouperStore().searchCodes(text);
}

function setPOA(value: string, index: number) {
    let temp = presentOnAdmissionDisplayMap[value];
    diagnosisCodes.value[index].poa = temp;
    currentRow.value = -1;
}

function titleText() {
    return `Diagnosis(${diagnosisCodes.value?.length || 0})`
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DataTable, {
      title: titleText(),
      rows: _unref(diagnosisCodes),
      columns: columns,
      type: _unref(CodeType).Diagnosis
    }, {
      "dt-header-top-right": _withCtx(() => [
        _createVNode(_component_q_btn, {
          "no-caps": "",
          dense: "",
          flat: "",
          rounded: "",
          class: "poa",
          onClick: setPOAsToYes
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Set POAs to Y ")
          ]),
          _: 1
        }),
        _createVNode(_component_q_btn, {
          "no-caps": "",
          dense: "",
          flat: "",
          rounded: "",
          class: "poa",
          onClick: calculateDRG
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Calculate DRG (Remove) ")
          ]),
          _: 1
        })
      ]),
      "dt-thead": _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (col) => {
              return _createElementVNode("th", {
                key: col.name
              }, _toDisplayString(col.label), 1)
            }), 64))
          ])
        ])
      ]),
      "dt-rows": _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(diagnosisCodes), (row, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: index,
            class: _normalizeClass(alternateRow(index))
          }, [
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_component_q_btn_dropdown, {
                "no-caps": "",
                dense: "",
                flat: "",
                round: "",
                class: "text-none",
                "dropdown-icon": "fa-solid fa-ellipsis-vertical",
                size: "sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_list, null, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, {
                            onClick: ($event: any) => (makePrinciple(index))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Make Principle")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)), [
                        [_directive_close_popup]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Open in Search")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_close_popup]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, {
                            onClick: ($event: any) => (deleteCode(index))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Delete Code")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)), [
                        [_directive_close_popup]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, {
                            onClick: ($event: any) => (editCode(index))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Edit")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)), [
                        [_directive_close_popup],
                        [_vShow, !editing(index)]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, {
                            onClick: ($event: any) => (resetCode(index))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Reset")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)), [
                        [_directive_close_popup],
                        [_vShow, editing(index)]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("td", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.pdx, (pdx, index) => {
                return (_openBlock(), _createBlock(_component_q_chip, {
                  key: index,
                  class: _normalizeClass(pdx)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(pdx), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            _createElementVNode("td", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.drgModifier, (drgModifier, index) => {
                return (_openBlock(), _createBlock(_component_q_chip, {
                  key: index,
                  class: _normalizeClass(drgModifier)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(drgModifier), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            _createElementVNode("td", _hoisted_5, [
              (!editing(index))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: ($event: any) => (editCode(index))
                  }, [
                    (row.edit)
                      ? (_openBlock(), _createBlock(_component_q_icon, {
                          key: 0,
                          name: "fa-solid fa-flag-pennant",
                          size: "xs",
                          class: _normalizeClass(["edit-flag", row.edit.level == 'Critical' ? 'critical' : 'warning'])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, { "max-width": "300px" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Edits Available")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(row.code), 1)
                  ], 8, _hoisted_6))
                : _createCommentVNode("", true),
              (editing(index))
                ? (_openBlock(), _createBlock(_component_q_input, {
                    key: 1,
                    dense: "",
                    outlined: "",
                    modelValue: row.code,
                    "onUpdate:modelValue": [($event: any) => ((row.code) = $event), ($event: any) => (searchCodes(row.code, index))],
                    placeholder: "Add Code",
                    autofocus: "",
                    size: "16px",
                    onKeydown: [
                      _cache[0] || (_cache[0] = _withKeys(_withModifiers(($event: any) => (saveCode()), ["prevent"]), ["enter"])),
                      _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (saveCode()), ["prevent"]), ["tab"]))
                    ]
                  }, {
                    prepend: _withCtx(() => [
                      (row.edit)
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 0,
                            name: "fa-solid fa-flag-pennant",
                            size: "xs",
                            class: _normalizeClass(["edit-flag", row.edit.level == 'Critical' ? 'critical' : 'warning'])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_tooltip, { "max-width": "300px" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Edits Available")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["class"]))
                        : _createCommentVNode("", true)
                    ]),
                    append: _withCtx(() => [
                      (row.description === '' && row.code)
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 0,
                            name: "fa-solid fa-circle-exclamation",
                            size: "16px"
                          }))
                        : (row.description && row.code)
                          ? (_openBlock(), _createBlock(_component_q_icon, {
                              key: 1,
                              name: "fa-solid fa-trash-can",
                              onClick: ($event: any) => (deleteCode(index)),
                              size: "16px"
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.description), 1)
                ]),
                _: 2
              }, 1024),
              _createTextVNode(" " + _toDisplayString(row.description), 1)
            ]),
            (!editing(index))
              ? (_openBlock(), _createElementBlock("td", {
                  key: "poa",
                  onClick: ($event: any) => (editCode(index))
                }, [
                  (row.poa)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(presentOnAdmissionMap)[row.poa]), 1))
                    : (_openBlock(), _createBlock(_component_q_icon, {
                        key: 1,
                        name: "fa-solid fa-triangle-exclamation",
                        size: "16px"
                      }))
                ], 8, _hoisted_8))
              : _createCommentVNode("", true),
            (editing(index))
              ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_btn_dropdown, {
                      label: _unref(presentOnAdmissionMap)[row.poa] || 'Set POA',
                      class: "poa-dropdown"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(presentOnAdmissionsDisplayValues), (poa, poaIndex) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: poaIndex,
                                clickable: "",
                                onClick: ($event: any) => (setPOA(poa, index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(poa), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("td", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.quality, (quality, index) => {
                return (_openBlock(), _createBlock(_component_q_chip, {
                  key: index,
                  class: _normalizeClass(quality)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(quality), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            _createElementVNode("td", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.risk, (risk, index) => {
                return (_openBlock(), _createBlock(_component_q_chip, {
                  key: index,
                  class: _normalizeClass(risk)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(risk), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ])
          ], 2))
        }), 128))
      ]),
      _: 1
    }, 8, ["title", "rows", "type"])
  ]))
}
}

})